import "./detailpage.scss";
import { useEffect, useState } from "react";

const DisputeTimer = ({ disputeTimer, setDisputeTimer }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!disputeTimer) return;
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const diff = disputeTimer - now;

      const newTimeLeft =
        diff <= 0
          ? { days: 0, hours: 0, minutes: 0, seconds: 0 }
          : {
            days: Math.floor(diff / (3600 * 24)),
            hours: Math.floor((diff % (3600 * 24)) / 3600),
            minutes: Math.floor((diff % 3600) / 60),
            seconds: diff % 60,
          };
      setTimeLeft(newTimeLeft);
      if (diff <= 0) {
        clearInterval(interval);
        setDisputeTimer(0);
      }

    }, 1000);

    return () => clearInterval(interval);
  }, [disputeTimer]);

  return (
    <div className="timer">
      <h5>{timeLeft?.days ?? 0}D</h5>
      <h5>{timeLeft?.hours ?? 0}H</h5>
      <h5>{timeLeft?.minutes ?? 0}M</h5>
      <h5>{timeLeft?.seconds ?? 0}S</h5>
    </div>
  );
};

export default DisputeTimer;

